import React from "react";

const ExerciseMatrixCategoryIds = (id) => {
    switch(id) {
        ////  CORRECTIVES  ////
        case 300:
          return [300,325,330,335,340,350,355,360,365,375,380,385,388,390,395]
        case 325:
          return [325,330,335,340];
        case 330:
          return [330];
        case 335:
          return [335];
        case 340:
          return [340];
        case 350:
          return [350,355,360,365];
        case 355:
          return [355];
        case 360:
          return [360];
        case 365:
          return [365];
        case 375:
          return [375,380,385,388];
        case 380:
          return [380];
        case 385:
          return [385];
        case 388:
          return [388];
        case 390:
          return [390];
        case 395:
          return [395];
        ////  FOAM ROLL  ////
        case 100:
          return [100,125,150];
        case 125:
          return [125];
        case 150:
          return [150];
        ////  PREP  ////
        case 200:
          return [200,225,250,275];
        case 225:
          return [225];
        case 250:
          return [250];
        case 275:
          return [275];
        ////  SLATE  ////
        case 400:
          return [400,425,430,431,432,433,434,440,441,442,443,444,450,455,456,457,465,466,467,475,480,481,482,483,484,485,488,489,490,491,492,493,495];
        // CORE ELASTICITY
        case 425:
          return [425,430,431,432,433,434,440,441,442,443,444];
        // VERTICAL
        case 430:
          return [430,431,432,433,434];
        case 431:
          return [431];
        case 432:
          return [432];
        case 433:
          return [433];
        case 434:
          return [434];
        case 441:
          return [441];
        case 442:
          return [442];
        case 443:
          return [443];
        case 444:
          return [444];
        case 456:
          return [456];
        case 457:
          return [457];
        case 466:
          return [466];
        case 467:
          return [467];
        case 481:
          return [481];
        case 482:
          return [482];
        case 483:
          return [483];
        case 484:
          return [484];
        case 485:
          return [485];
        case 489:
          return [489];
        case 490:
          return [490];
        case 491:
          return [491];
        case 492:
          return [492];
        case 493:
          return [493];
        case 495:
          return [495];

        // ROTATIONAL
        case 440:
          return [440,441,442,443,444];
        // LOWER BODY ELASTICITY
        case 450:
          return [450,455,456,457,465,466,467];
        // BILATERAL
        case 455:
          return [455,456,457];
        // UNILATERAL
        case 465:
          return [465,466,467];
        // CLOSED CHAIN AGILITY
        case 475:
          return [475,480,481,482,483,484,485,488,489,490,491,492,493];
        // LINEAR
        case 480:
          return [480,481,482,483,484,485];        // LATERAL & COMBINATION
        case 488:
          return [488,489,490,491,492,493];

        ////  STRENGTH  ////
        case 500:
          return [500,525,530,531,532,535,536,537,540,541,542,545,546,547,550,551,552,555,560,575,625,675];
        case 525:
          return [525,530,531,532,535,536,537,540,541,542,545,546,547,550,551,552,555,560];
        case 530:
          return [530,531,532];
        case 531:
          return [531];
        case 532:
          return [532];
        case 535:
          return [535,536,537];
        case 536:
          return [536];
        case 537:
          return [537];
        case 540:
          return [540,541,542];
        case 541:
          return [541];
        case 542:
          return [542];
        case 545:
          return [545,546,547];
        case 546:
          return [546];
        case 547:
          return [547];
        case 550:
          return [550,551,552];
        case 551:
          return [551];
        case 552:
          return [552];
        case 555:
          return [555];
        case 560:
          return [560];
        case 575:
          return [575,580,590,591,592,593,594,600,601,602,603,610,611,612,613,614];
        case 580:
          return [580];
        case 590:
          return [590,591,592,593,594];
        case 591:
          return [591];
        case 592:
          return [592];
        case 593:
          return [593];
        case 594:
          return [594];
        case 600:
          return [600,601,602,603];
        case 601:
          return [601];
        case 602:
          return [602];
        case 603:
          return [603];
        case 610:
          return [610,611,612,613,614];
        case 611:
          return [611];
        case 612:
          return [612];
        case 613:
          return [613];
        case 614:
          return [614];
        case 625:
          return [625,635,636,637,638,639,640,645,46,647,655,665];
        case 635:
          return [635,636,637,638,639,640];
        case 636:
          return [636];
        case 637:
          return [637];
        case 638:
          return [638];
        case 639:
          return [639];
        case 640:
          return [640];
        case 645:
          return [645,646,647];
        case 646:
          return [646];
        case 647:
          return [647];
        case 655:
          return [655];
        case 665:
          return [665];
        case 675:
          return [675,680,685,690,695,700,710];
        case 680:
          return [680];
        case 685:
          return [685];
        case 690:
          return [690];
        case 695:
          return [695];
        case 700:
          return [700];
        case 710:
          return [710];
      }
}

export default ExerciseMatrixCategoryIds;



// WEBPACK FOOTER //
// ./src/utils/ExerciseMatrixCategoryIds.js